import React from "react";
import { serviceBanners } from "../../../config";
import ContactButton from "../../MainComponents/ContactButton";

const ServiceBanner = ({
  image = serviceBanners.bannerOne,
  title = "",
  description = "",
}) => {
  return (
    <div>
      <div className="w-full bg-gradient-to-br from-darkBackground to-primary flex flex-col-reverse justify-center items-center lg:flex-row">
        {/* Image Section */}
        <div className="w-full lg:w-[60%] pt-8 flex justify-center">
          <img
            src={image}
            alt="Service Detail"
            className="w-[90%] md:w-[80%] lg:w-[90%] rounded-t-lg h-auto mb-4 lg:mb-0"
          />
        </div>

        {/* Text Section */}
        <div className="w-full font-primary flex flex-col lg:w-1/2 mt-8 lg:py-4 px-6 lg:px-8 ">
          <h1 className="text-2xl md:text-3xl lg:text-4xl text-center lg:text-start font-bold text-white mb-5">
            {title}
          </h1>
          <p className="mt-4 text-white text-lg/8 md:text-l/10 text-center  lg:text-start lg:w-[90%]">
            {description}
          </p>
          <ContactButton
            mainContStyle="mt-8 flex flex-col justify-start sm:flex-row items-center space-y-4 sm:space-y-0 sm:space-x-4"
            bookOnlinestyle="bg-orange text-white py-4 px-8 rounded-full font-semibold text-center"
            callButtonStyle="bg-transparent text-white py-4 px-8 rounded-full font-semibold text-center"
          />
        </div>
      </div>
    </div>
  );
};

export default ServiceBanner;